import React from 'react';
import cn from 'classnames';

var styles = {"component":"skeleton__component_1df6c","allowBackdropBlur":"skeleton__allowBackdropBlur_1df6c","animate":"skeleton__animate_1df6c","background":"skeleton__background_1df6c"};
require('./index.css')

var Skeleton = function (_a) {
    var _b;
    var visible = _a.visible, _c = _a.animate, animate = _c === void 0 ? true : _c, className = _a.className, dataTestId = _a.dataTestId, children = _a.children, style = _a.style, allowBackdropBlur = _a.allowBackdropBlur;
    if (visible) {
        return (React.createElement("div", { className: cn(styles.component, (_b = {},
                _b[styles.animate] = animate,
                _b[styles.allowBackdropBlur] = allowBackdropBlur,
                _b), className), style: style, "data-test-id": dataTestId }, children));
    }
    return (React.createElement("div", { "data-test-id": dataTestId, className: className, style: style }, children));
};

export { Skeleton };
